export var composeUniqueKey = function composeUniqueKey(props, index) {
  if (props.key) {
    return props.key;
  }
  return index;
};